import React from 'react';

function Pricing({ scrollToSection }) {
  const packages = [
    {
      name: 'Starter',
      price: '$499',
      popular: false,
      description: 'Perfect for small businesses & startups',
      features: [
        '5-page responsive website',
        'Mobile-friendly design',
        'Contact form integration',
        'Basic SEO setup',
        'Social media links',
        '30 days free support',
        '2-week delivery'
      ],
      cta: 'Get Started'
    },
    {
      name: 'Professional',
      price: '$1,499',
      popular: true,
      description: 'Most popular for growing businesses',
      features: [
        '10-page custom website',
        'Premium design',
        'CMS (WordPress/Laravel)',
        'Advanced SEO optimization',
        'Blog integration',
        'Email integration',
        'Analytics setup',
        '90 days free support',
        '2-week delivery'
      ],
      cta: 'Get Started'
    },
    {
      name: 'E-Commerce',
      price: '$2,999',
      popular: false,
      description: 'Full online store solution',
      features: [
        'Shopify/WooCommerce store',
        'Unlimited products',
        'Payment gateway integration',
        'Inventory management',
        'Shipping integration',
        'Custom design',
        'Product SEO',
        'Email marketing setup',
        '6 months free support',
        '3-week delivery'
      ],
      cta: 'Get Started'
    },
    {
      name: 'Mobile App',
      price: '$4,999',
      popular: false,
      description: 'iOS & Android hybrid app',
      features: [
        'Cross-platform app',
        'iOS & Android',
        'Custom design',
        'Push notifications',
        'API integration',
        'Admin panel',
        'App store deployment',
        '1 year free support',
        '4-week delivery'
      ],
      cta: 'Get Started'
    }
  ];

  return (
    <section id="pricing" className="pricing">
      <div className="pricing-container">
        <div className="pricing-header">
          <div className="section-label">TRANSPARENT PRICING</div>
          <h2 className="pricing-title">Choose Your Perfect Package</h2>
          <p className="pricing-subtitle">
            No hidden fees. No surprises. Just honest pricing with guaranteed results.
          </p>
        </div>

        <div className="pricing-grid">
          {packages.map((pkg, index) => (
            <div key={index} className={`pricing-card ${pkg.popular ? 'popular' : ''}`}>
              {pkg.popular && <div className="popular-badge">MOST POPULAR</div>}
              <div className="package-header">
                <h3 className="package-name">{pkg.name}</h3>
                <div className="package-price">
                  {pkg.price}
                  <span className="price-period">/project</span>
                </div>
                <p className="package-description">{pkg.description}</p>
              </div>
              
              <ul className="package-features">
                {pkg.features.map((feature, idx) => (
                  <li key={idx}>
                    <span className="feature-check">✓</span> {feature}
                  </li>
                ))}
              </ul>

              <button 
                className="package-cta"
                onClick={() => scrollToSection('contact')}
              >
                {pkg.cta} →
              </button>
            </div>
          ))}
        </div>

        <div className="pricing-guarantee">
          <div className="guarantee-content">
            {/*<div className="guarantee-icon">🛡️</div>
            <div className="guarantee-text">
              <h4>100% Money-Back Guarantee</h4>
              <p>Not satisfied? Get a full refund within 30 days. No questions asked.</p>
            </div>*/}
            <div className="guarantee-icon">🔧</div>
            <div className="guarantee-text">
              <h4>Dedicated Support & Maintenance</h4>
              <p>Get 30 days of free post-launch support to ensure everything runs smoothly. We handle the bugs, so you don't have to worry.</p>
            </div>
          </div>
          <div className="guarantee-content">
            <div className="guarantee-icon">💳</div>
            <div className="guarantee-text">
              <h4>Flexible Payment Plans</h4>
              <p>Pay 50% upfront, 50% on completion. Or split into 3 monthly installments.</p>
            </div>
          </div>
        </div>

        <div className="pricing-cta-section">
          <h3>Need a Custom Solution?</h3>
          <p>Tell us about your project and we'll create a tailored package just for you.</p>
          <button 
            className="custom-quote-btn"
            onClick={() => scrollToSection('contact')}
          >
            Get Custom Quote →
          </button>
        </div>
      </div>
    </section>
  );
}

export default Pricing;
